import { useContext } from 'react';
import { Home_context } from '../../context/home_context';

// export default function Header__descriptions(){
//     return(
//         <>
//         <p className="text-start page_pera_font_size page_pera_color " >
//             We have developed a unique extraction process utilizing a proprietary solvent system for the extraction of glycolipids from
// crushed barley grain. The extraction procedure uses no organic solvent. This innovative extraction procedure utilizes
// filtration, differential solubility and heat extraction to optimize the efficiency of the process in order to provide a more
// economical means of obtaining high purity phyto-sphingolipids. The extract contains between 3 to 6% cerebrosides along
// with a small amount of protein and fatty acids. The remainder being no polar hydrocarbons, phospholipids and phytosterol.
//         </p>
//         <div className="flex items-center gap-4" >
//         <a  className="text-[blue] text-[15px] " href="blank">Product Information</a>
//         <a  className="text-[blue] text-[15px] " href="blank">MSDS</a>
//         </div>
//         </>
//     )
// }

export default function Header__descriptions() {
  const { report_data_state } = useContext(Home_context);
  return (
    <>
      <p className=" non_table_block_padding text-start page_pera_font_size page_pera_color ">
        {report_data_state?.report_data['presentation_en']}
      </p>
    </>
  );
}
